/*
 * @Author: hai.zhang
 * @LastEditors: Shaoyan Zhang
 * @Date: 2019-08-19 10:12:38
 * @LastEditTime: 2021-07-12 11:09:27
 */
export default {
  fixed: [
    {
      name: 'paas-edit',
      path: '/paas/edit/:tenantType/:objectApiName/:layoutApiName/:permissionPointCode',
      component: () => import(/* webpackChunkName: "cart" */'../routes/paas/edit/index.vue'),
      meta: {
        title: 'paas',
        noTranslation: true,
        isNewHeader: true
      }
    },
    {
      name: 'paas-detail',
      path: '/paas/detail/:tenantType/:objectApiName/:layoutApiName/:permissionPointCode',
      component: () => import(/* webpackChunkName: "cart" */'../routes/paas/detail/index.vue'),
      meta: {
        title: 'paas',
        noTranslation: true,
        isNewHeader: true
      }
    },
    {
      name: 'paas-platform-preset-create',
      path: '/paas/platform-preset-create-:objectApiName-:layoutApiName',
      component: () => import(/* webpackChunkName: "paas-platform-preset-create" */'../routes/paas/platform-preset/create/index.vue'),
      meta: {
        title: {
          'zh-CN': '新增',
          en: '新增_en',
          jp: '新增_jp'
        },
        noTranslation: true,
        isNewHeader: true
      }
    },
    {
      name: 'paas-platform-preset-detail',
      path: '/paas/platform-preset-detail-:objectApiName-:layoutApiName',
      component: () => import(/* webpackChunkName: "paas-platform-preset-detail" */'../routes/paas/platform-preset/detail/index.vue'),
      meta: {
        title: {
          'zh-CN': '详情',
          en: '详情_en',
          jp: '详情_jp'
        },
        noTranslation: true,
        isNewHeader: true
      }
    }
  ],
  fluid: [
    {
      name: 'paas-list',
      path: '/paas/list/:tenantType/:objectApiName/:layoutApiName',
      component: () => import(/* webpackChunkName: "PaasList" */'../routes/paas/list/index.vue'),
      meta: {
        title: {
          'zh-CN': '列表',
          en: '列表_en',
          jp: '列表_jp'
        },
        noTranslation: true
      }
    },
    {
      name: 'paas-platform-preset-list',
      path: '/paas/platform-preset-list-:objectApiName-:layoutApiName',
      component: () => import(/* webpackChunkName: "paas-platform-preset-list" */'../routes/paas/platform-preset/list/index.vue'),
      meta: {
        title: {
          'zh-CN': '列表',
          en: '列表_en',
          jp: '列表_jp'
        },
        noTranslation: true
      }
    }
  ],
  full: [
  ]
}
